import Box from '@/components/UI/box/Box';
import styles from './HouseBundleBanner.module.scss';
// import Image from 'next/image'
import Typography from '@/components/UI/typography/Typography';
// import celebrateIcon from '@/public/images/bundle-icon/celebrate-icon.webp'
import { DiscountMotivation } from '@/components/search/_types/searchDataType';
import { FC } from 'react';
interface HouseBundleBannerProps {
  data: DiscountMotivation;
}
const HouseBundleBanner: FC<HouseBundleBannerProps> = ({
  data
}) => {
  const handleJoinWords = (words: string[]) => {
    if (words.length === 0) return '';
    if (words.length === 1) return words[0];
    if (words.length === 2) return words[0] + ' و ' + words[1];
    const allButLastTwo = words.slice(0, -2).join(', ');
    const lastTwo = words.slice(-2).join(' و ');
    return allButLastTwo + ', ' + lastTwo;
  };
  return <Box className={styles['bundle-banner-container']} component={'section'} data-sentry-element="Box" data-sentry-component="HouseBundleBanner" data-sentry-source-file="HouseBundleBanner.tsx">
      {/* <Box className={styles['icon']}>
        <Image src={celebrateIcon} alt={'bundle'} width={28} height={28} />
       </Box> */}
      <Box className={styles['description']} data-sentry-element="Box" data-sentry-source-file="HouseBundleBanner.tsx">
        <Typography variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="HouseBundleBanner.tsx">
          {data.total_discount_amount} تومان هدیه‌ی همراهی، چون همیشه کنارتیم!
        </Typography>
        <Typography variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="HouseBundleBanner.tsx">
          قابل استفاده در {handleJoinWords(data.companies)}
        </Typography>
      </Box>
    </Box>;
};
export default HouseBundleBanner;